/*
 * Copyright (c) 2021. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import LpDivorceAgreementMeta from "./LpDivorceAgreementMeta";
import Container from "../../../../../components/Container/Container";
import DivorceCheckin from "../../../../../components/Checkin/DivorceCheckin/DivorceCheckin";
import { landingPagesList } from "../../../../../services/landingPagesList";
import { getLastPathSplit } from "../../../../../services/redirect";
import DivorceAgreementSection from "../../../../../components/Sections/Divorce/DivorceAgreementSection/DivorceAgreementSection";
import ServiceSection from "../../../../../components/Sections/Generic/ServiceSection/ServiceSection";
import ProcedureDivorceSection from "../../../../../components/Sections/Divorce/ProcedureDivorceSection/ProcedureDivorceSection";
import Layout from "../../../../Layouts/Layout";
import BirdMapSection from "../../../../../components/Sections/Divorce/BirdMapSection/BirdMapSection";
import TeamSection from "../../../../../components/Sections/Generic/TeamSection/TeamSection";
import TrustSection from "../../../../../components/Sections/Generic/TrustSection/TrustSection";
import LandingPageTeaser from "../../../../../components/Teaser/LandingPageTeaser";
import AdvantagesLegalbirdAttorneySection from "../../../../../components/Sections/Generic/AdvantagesLegalbirdAttorneySection/AdvantagesLegalbirdAttorneySection";
import PartnersSection from "../../../../../components/Sections/Generic/PartnersSection/PartnersSection";
import ServiceTeaser from "../../../../../components/Teaser/ServiceTeaser";
import { divorceTeaserCards } from "../../../../../services/landingPageService";
import GreyBackgroundWrapper from "../../../../../components/BackgroundWrapper/GreyBackgroundWrapper";
import LinkedCardBox from "../../../../../components/LinkedCardBox/LinkedCardBox";
import { useLocation } from "react-router";
import { useCustomer } from "../../../../../provider/Customer/CustomerProvider";

const LpDivorceAgreement = () => {
  const location = useLocation();
  const lpKey = getLastPathSplit(location.pathname);
  const keyword = (lpKey && landingPagesList[lpKey]?.keyword) ?? "Scheidungsfolgenvereinbarung";
  const headline = <span>Scheidungsfolgen&#8203;vereinbarung</span>; // special case: always use this due to the headline length

  const { isLoggedIn } = useCustomer();

  return (
    <Layout minimal={!isLoggedIn} clickableLogo={isLoggedIn} backgroundType={"landingpage"}>
      <LpDivorceAgreementMeta keyword={keyword} />
      <LandingPageTeaser
        headline={headline}
        subheadline={"Trennen Sie sich im Guten und sparen Sie Geld!"}
        teaserButtonLink={isLoggedIn ? "/servicewelt" : "#top-checkin"}
      >
        <LinkedCardBox linkedCards={divorceTeaserCards} />
      </LandingPageTeaser>
      <GreyBackgroundWrapper>
        {!isLoggedIn && (
          <Container>
            <DivorceCheckin
              checkinHeading={"Jetzt kostenlos registrieren und alle Informationen erhalten"}
              idPrefix={"top"}
              target={"/scheidung/wichtige-themen-ueberblick"}
            />
          </Container>
        )}
        <DivorceAgreementSection />
      </GreyBackgroundWrapper>
      <ProcedureDivorceSection />
      <ServiceTeaser />
      <ServiceSection product={"divorce"} />
      <TeamSection isSubsection={true} />
      <GreyBackgroundWrapper>
        <BirdMapSection />
        <AdvantagesLegalbirdAttorneySection />
      </GreyBackgroundWrapper>
      <TrustSection />
      {!isLoggedIn && (
        <Container>
          <DivorceCheckin
            checkinHeading={"Jetzt kostenlos registrieren und alle Informationen erhalten"}
            idPrefix={"bottom"}
            target={"/scheidung/wichtige-themen-ueberblick"}
          />
        </Container>
      )}
      <PartnersSection />
    </Layout>
  );
};

export default LpDivorceAgreement;
